import { render, staticRenderFns } from "./AddInvoice.vue?vue&type=template&id=140d035f&scoped=true"
import script from "./AddInvoice.vue?vue&type=script&lang=js"
export * from "./AddInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140d035f",
  null
  
)

export default component.exports